module.exports = __webpack_public_path__ + "278f918717d163eeee09b468893f7c53.png";


//////////////////
// WEBPACK FOOTER
// ./img/mobile/m-service-img1-en.png
// module id = 241
// module chunks = 2